import React from 'react';

/**
 * Sprint 11, story-042 (U77). "X of Y required captured" progress readout — the number a PM
 * scanning many stores in sequence needs without reading every cell, per
 * docs/ux/story-042-design.md.
 */
export const EvidenceSummaryBar: React.FC<{ requiredTotal: number; requiredFilled: number }> = ({
  requiredTotal,
  requiredFilled,
}) => {
  const pct = requiredTotal > 0 ? Math.round((requiredFilled / requiredTotal) * 100) : 100;

  return (
    <div className="flex items-center gap-3 py-2" data-testid="evidence-summary-bar">
      <div className="flex-1 h-2 rounded-full bg-frozenGrayShades2 dark:bg-frozenGrayShades8 overflow-hidden">
        <div
          className="h-full bg-emerald-500 transition-all"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
      <span className="text-sm whitespace-nowrap text-frozenGrayShades7 dark:text-frozenGrayShades3">
        {requiredFilled} of {requiredTotal} required captured
      </span>
    </div>
  );
};

export default EvidenceSummaryBar;
